export const NotFoundPage = () => {
  return (
    <h1 className="title">Page not found</h1>
  );
};
